import { Pipe, PipeTransform } from '@angular/core';
import { EntryType, RemittanceEntryAggregate } from '@models/dashboard/model';

@Pipe({ name: 'remittanceEntryDetailsDisplay' })
export class RemittanceEntryDetailsDisplayPipe implements PipeTransform {
  public transform(data: RemittanceEntryAggregate): string {
    switch (data.entryType) {
      case EntryType.ClientRemittanceDistribution:
      case EntryType.PayeeRemittanceDistribution:
        return 'Distribution';
      case EntryType.PaymentAccountPayeeBaseRemittance:
      case EntryType.PaymentAccountClientBaseRemittance:
        return `${data.paymentPlanName} - Payment Plan Remittance`;
      case EntryType.PaymentAccountClientFeeRemittance:
      case EntryType.PaymentAccountPayeeFeeRemittance:
        return `${data.paymentPlanName} - Fee Remittance`;
      case EntryType.PaymentAccountPayeeSurchargeRemittance:
      case EntryType.PaymentAccountClientSurchargeRemittance:
        return `${data.paymentPlanName} - Surcharge Remittance`;
      case EntryType.PaymentAccountClientFeeRemittanceReversal:
      case EntryType.PaymentAccountPayeeFeeRemittanceReversal:
        return `${data.paymentPlanName} - Fee Remittance Reversal`;
      case EntryType.PaymentAccountClientBaseRemittanceReversal:
      case EntryType.PaymentAccountPayeeBaseRemittanceReversal:
        return `${data.paymentPlanName} - Payment Plan Remittance Reversal`;
      case EntryType.PaymentAccountPayeeSurchargeRemittanceReversal:
      case EntryType.PaymentAccountClientSurchargeRemittanceReversal:
        return `${data.paymentPlanName} - Surcharge Remittance Reversal`;
      case EntryType.PaymentAccountClientUnremittance:
        return `${data.paymentPlanName} - Client Unremittance`;
      case EntryType.PaymentAccountPayeeUnremittance:
        return `${data.paymentPlanName} - Payee Unremittance`;
      case EntryType.ClientRemittanceAccountPositiveAdjustment:
      case EntryType.ClientRemittanceAccountNegativeAdjustment:
      case EntryType.PayeeRemittanceAccountPositiveAdjustment:
      case EntryType.PayeeRemittanceAccountNegativeAdjustment:
        return 'Adjustment';
      default:
        return 'Remittance';
    }
  }
}
